module.exports = __webpack_public_path__ + "img/youtube.22d8118e.svg";